export default "__VITE_ASSET__DBrrpgqP__"